export default "__VITE_ASSET__uNje_ULb__"